import { MarkovModel } from "server/models"
import { OrderType } from "client/utils"

export interface MarkovModelProps {
    modelId: number
    hash?: string
}

export type MarkovModelValidation = { [key in keyof MarkovModel]?: string}

export interface MarkovModelList { [modelId: number]: MarkovModel }
export interface MarkovModelFilters {
    search?: string
}

export interface MarkovModelState {
    modelList: MarkovModelList
    modelIds: readonly number[]
    modelView: MarkovModel
    modelEdit: MarkovModel

    sortColumn: keyof MarkovModel
    sortOrder: OrderType
    filters: MarkovModelFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const MARKOV_MODEL_LIST = "MARKOV_MODEL_LIST"
export const MARKOV_MODEL_IDS = "MARKOV_MODEL_IDS"
export const MARKOV_MODEL_VIEW = "MARKOV_MODEL_VIEW"
export const MARKOV_MODEL_EDIT = "MARKOV_MODEL_EDIT"

export const MARKOV_MODEL_SORT = "MARKOV_MODEL_SORT"
export const MARKOV_MODEL_FILTERS = "MARKOV_MODEL_FILTERS"

export const MARKOV_MODEL_RELOAD_LIST = "MARKOV_MODEL_RELOAD_LIST"
export const MARKOV_MODEL_RELOAD_VIEW = "MARKOV_MODEL_RELOAD_VIEW"
export const MARKOV_MODEL_RELOAD_EDIT = "MARKOV_MODEL_RELOAD_EDIT"
